import {
  StyleSheet,
} from 'react-native';

import {
  primaryFont300,
  primaryFont500,
} from '../Common';

export default StyleSheet.create({
  panel_hover: {
    backgroundColor: '#e0e0e0',
    // cursor: 'pointer',
  },
  panel: {
    flex: 1,
    flexDirection: 'row',
    borderRadius: 5,
    margin: 20,
    marginBottom: 0,
    height: 64,
    minHeight: 64,
    maxHeight: 64,
  },
  panelInner: {
    flex: 1,
    flexDirection: 'column',
    minHeight: 64,
    maxHeight: 64,
    height: 64,
    justifyContent: 'space-around',
  },
  panelRating: {
    flexDirection: 'row',
  },
  imageBlock: {
    // borderColor: 'white',
    borderWidth: 0,
    // borderRadius: 32,
    // justifyContent: 'flex-start',
    width: 64,
    minHeight: 64,
    height: 64,
    // minHeight: 64,
    // minWidth: 64,
    backgroundColor: '#e0e0e0',
    // backgroundClip: 'content-box',
    // borderWidth: 1, // px
    // borderStyle: 'solid',
    // borderColor: 'grey',
    margin: 0,
    padding: 0,
    // resizeMode: 'cover',
    // resizeMode: 'center',
  },
  imageBlockNone: {
    // borderColor: 'white',
    borderWidth: 0,
    // borderRadius: 32,
    // justifyContent: 'flex-start',
    width: 64,
    minHeight: 64,
    height: 64,
    // minHeight: 64,
    // minWidth: 64,
    backgroundColor: '#e0e0e0',
    // backgroundClip: 'content-box',
    // borderWidth: 1, // px
    // borderStyle: 'solid',
    // borderColor: 'grey',
    margin: 0,
    padding: 0,
    // resizeMode: 'cover',
    // resizeMode: 'center',
    // overflow: 'hidden',
  },
  image_img: {
    maxWidth: '100%',
    height: 'auto',
  },
  name: {
    // font: "bold italic 1.5em \"Fira Sans\", sans-serif",
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    // borderWidth: 1,
    // borderColor: 'red',
    // borderStyle: 'solid',
    fontSize: 14,
    fontFamily: primaryFont500,
    fontWeight: '500',
    lineHeight: 17,
    marginBottom: 7,
    marginRight: 10,
    marginLeft: 15,
  },
  description: {
    // borderWidth: 1,
    // borderColor: 'red',
    // borderStyle: 'solid',
    // font: "italic 1.0em \"Fira Sans\", sans-serif",
    height: 34,
    maxHeight: 34,
    overflow: 'hidden',
    // numberOfLines: 2,
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 13,
    marginLeft: 15,
  },
  rating: {
    height: 17,
    minHeight: 17,
    marginTop: 5,
    marginBottom: 7,
  },
  reviews: {
    marginTop: 5,
    marginBottom: 7,
    paddingLeft: 5,
    textAlignVertical: 'center',
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 17,
  },
});
